<template>
  <div class="inner">
    <div
      v-if="showMenu"
      class="menu"
      :style="menuStyle"
      v-on-clickaway="hideMenu"
    >
      <a v-if="allowDownload" @click.prevent="download">
        <b-icon icon="download" size="is-small" />
        Télécharger
      </a>
      <a @click.prevent="voirApercu">
        <b-icon icon="search" size="is-small" />
        Aperçu
      </a>
      <a v-if="allowQuestions" @click.prevent="poserQuestion">
        <b-icon icon="question-circle" size="is-small" />
        Poser une question
      </a>
    </div>
    <div v-for="item in documents" :key="item.id" class="item">
      <span
        @click="click($event, item.id, item.name)"
        v-bind:class="{ changed: item.modified }"
      >
        <b-icon
          v-bind:icon="
            getIcon(item.extension) ? getIcon(item.extension) : 'file'
          "
          v-bind:class="getIcon(item.extension) ? getIcon(item.extension) : ''"
          :key="item.extension"
          pack="far"
          size="is-small"
        />
        {{ item.name }}
        <span v-if="!isRead(item.id)" class="unread"> * </span>
      </span>
      <div v-if="showFiles === item.id" class="files">
        <span
          v-for="(file, index) in documentFiles(item.id)"
          :key="item.id + '-' + index"
          @click="clickFile($event, item.id, index)"
        >
          {{ file.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import { degrees, PDFDocument, rgb } from 'pdf-lib'

import MixinDownload from '@/mixins/Download'
import MixinDocumentHelper from '@/mixins/DocumentHelper'
import PortefeuilleQuestionModal from '@/components/Portefeuille/QuestionModal'

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
  },
  mixins: [clickaway, MixinDownload, MixinDocumentHelper],
  data () {
    return {
      selectedFileName: null,
      showMenu: null,
      showFiles: null,
      menuStyle: {
        top: 0,
        left: 0,
      },
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      allowDownload: 'inv/allowDownload',
      allowQuestions: 'inv/allowQuestions',
      filigraneActivated: 'inv/filigraneActivated',
    }),
    ...mapState(['user']),
    params () {
      let params = {}
      if (this.$route.params.portefeuille) params.portefeuille = this.$route.params.portefeuille
      if (this.$route.params.site) params.site = this.$route.params.site
      if (this.$route.params.bien) params.bien = this.$route.params.bien
      if (this.$route.query.an1) params.an1 = this.$route.query.an1
      if (this.$route.query.an2) params.an2 = this.$route.query.an2
      if (this.$route.query.an3) params.an3 = this.$route.query.an3
      if (this.$route.query.an4) params.an4 = this.$route.query.an4
      if (this.$route.query.an5) params.an5 = this.$route.query.an5
      if (this.$route.query.an6) params.an6 = this.$route.query.an6
      if (this.$route.query.an7) params.an7 = this.$route.query.an7
      if (this.$route.query.an8) params.an8 = this.$route.query.an8
      if (this.$route.query.an9) params.an9 = this.$route.query.an9
      params.user = this.getUser()
      params.addWatermark = this.filigraneActivated
      return params
    },
    index () {
      if (!this.$route.query.invdoc) return 0
      return this.$route.query.invdoc.split('-')[1]
    },
  },
  methods: {
    idDoc () {
      if (!this.$route.query.invdoc) return 0
      return this.$route.query.invdoc.split('-')[0]
    },
    getUser () {
      return this.user.name
    },
    documentFiles (id) {
      const details = this.$store.state.inv.documentsDetails[id] || null
      if (!details) return []
      return details.files
    },
    getIcon (extension) {
      switch (extension.toLowerCase()) {
        case 'xls':
        case 'xlsx':
        case 'excel':
          return 'file-excel'
        case 'txt':
        case 'md':
          return 'file-alt'
        case 'doc':
        case 'docx':
        case 'word':
          return 'file-word'
        case 'ppt':
        case 'pptx':
        case 'powerpoint':
          return 'file-powerpoint'
        case 'pdf':
          return 'file-pdf'
        case 'jpg':
        case 'png':
        case 'bmp':
        case 'jpeg':
        case 'gif':
          return 'file-image'
        default:
          return null
      }
    },
    download () {
      let [id, index] = this.showMenu.split('-')
      var name = this.selectedFileName
      // if (this.filigraneActivated && name.toLowerCase().indexOf('.pdf') !== -1) {
      //   this.addWatermarkAndDownload(name, id)
      // } else {
      // this.params['user'] = this.getUser()
      // this.params['addWatermark'] = this.filigraneActivated

      this.downloadDocument(id, this.index, this.params, this.selectedFileName)
      // }
    },
    // getWatermark () {
    //   const date = new Date()
    //   const jour = date.getDate()
    //   const mois = date.getMonth() + 1
    //   const annee = date.getFullYear()
    //   let user = this.getUser()
    //   const text = `Confidentiel - Téléchargé le ${jour}/${mois}/${annee} par ${user} `
    //   return text
    // },
    /**
     * Download File with watermark
     */
    // async addWatermarkAndDownload (Filename, id) {
    //   const watermarkText = this.getWatermark()
    //   const url = this.documentUrl(id, this.index, this.params) + '&pdf'
    //   const response = await fetch(url)
    //   if (!response.ok) {
    //     throw new Error("Impossible de récupérer le fichier PDF depuis l'URL.")
    //   }
    //   const pdfBytes = await response.arrayBuffer()
    //   // Initialisez un objet PDFDocument
    //   const pdfDoc = await PDFDocument.load(pdfBytes)
    //   const pages = await pdfDoc.getPages()
    //   for (const page of pages) {
    //     const { width, height, rotate } = page.getSize()
    //     const fontSize = this.calculateFontSizeDL(watermarkText.length, width)

    //     let longueurPage = height
    //     let largeurPage = width

    //     let CentreX = largeurPage / 2 + 100
    //     let CentreY = longueurPage / 2 - 50

    //     const watermarkHeight = fontSize / 2

    //     let placementX = (watermarkText.length / 3) * watermarkHeight
    //     let placementY = (watermarkText.length / 3) * watermarkHeight

    //     const watermark = page.drawText(watermarkText, {
    //       x: CentreX - placementX,
    //       y: CentreY - placementY,
    //       size: fontSize,
    //       color: rgb(0.5, 0.5, 0.5), // Couleur du watermark
    //       rotate: degrees(60),
    //       opacity: 0.5,
    //     })
    //   }

    //   // Enregistrez le document PDF modifié
    //   const modifiedPdfBytes = await pdfDoc.save()

    //   // Créez un objet URL pour le Blob
    //   const url2 = window.URL.createObjectURL(new Blob([modifiedPdfBytes]))
    //   // Créez un lien d'ancrage pour le téléchargement
    //   const a = document.createElement('a')
    //   a.style.display = 'none'
    //   a.href = url2
    //   a.download = Filename + '.pdf'
    //   document.body.appendChild(a)
    //   a.click()

    //   window.URL.revokeObjectURL(url)
    // },

    calculateFontSizeDL (textLength, pageWidth) {
      const baseFontSize = 30 // Taille de police de base
      const maxWidthPercentage = 3 // Pourcentage de la largeur de la page pour la taille maximale

      // Calculer la taille de police en fonction de la longueur du texte et la largeur de la page
      const fontSize = Math.min(
        (pageWidth * maxWidthPercentage) / textLength,
        baseFontSize
      )

      return fontSize
    },

    async click( ev, id, name) {
      this.selectedFileName = name
      try {
        await this.$store.dispatch('inv/getDocumentDetails', id)
      } catch (e) {
        this.apiError(e)
      }

      const details = this.$store.state.inv.documentsDetails[id]
      if (!details) return

      if (this.showFiles === id) {
        this.showFiles = null
      } else if (details.files.length <= 1) {
        this.showFiles = null
        this.$nextTick(() => {
          this.menuStyle.top = ev.layerY + 'px'
          this.menuStyle.left = ev.layerX + 'px'
          this.showMenu = id + '-0'
        })
      } else {
        this.showFiles = id
      }
    },
    clickFile (ev, id, index) {
      this.$nextTick(() => {
        this.menuStyle.top = ev.layerY + 'px'
        this.menuStyle.left = ev.layerX + 'px'
        this.showMenu = id + '-' + index
      })
    },
    hideMenu () {
      this.showMenu = null
    },
    poserQuestion () {
      this.$modal.open({
        parent: this,
        component: PortefeuilleQuestionModal,
        hasModalCard: true,
        props: {
          document: +this.showMenu.replace(/-.*/, ''),
          an: this.id,
        },
        events: {
          sent () {
            window.dispatchEvent(new Event('refreshQuestions'))
          },
        },
      })
    },
    voirApercu () {
      this.$router.replace({
        query: {
          ['an' + this.level]: this.id,
          invdoc: this.showMenu,
        },
      })
      this.showMenu = null
    },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  min-height: 10px;
}
.item {
  font-size: 0.9em;
  padding: 0.2em 0 0.2em 0.5em;
  span {
    cursor: pointer;
    &:hover {
      color: #ed9e1a;
    }
  }
}
.changed {
  color: #35a0d0;
}
.files {
  padding-bottom: 1em;
  span {
    display: block;
    padding: 3px 0 3px 26px;
  }
}
.icon {
  margin-right: 0.15em;
}
.file-pdf {
  color: #ff0000;
}
.file-excel {
  color: #1d6f42;
}
.file-powerpoint {
  color: #d04423;
}
.file-word {
  color: #00a4ef;
}
.file-image {
  color: #0c00ef;
}
.file-alt {
  color: #000;
}

.menu {
  position: absolute;
  padding: 0.2em 0.5em;
  background: #fff;
  border: 2px solid #ccc;
  z-index: 2;
  a {
    display: block;
    font-size: 0.75em;
    padding: 0.3em 0;
  }
}
span.unread {
  font-weight: bold;
  color: #ed9e1a;
}
.changed span.unread {
  color: #ed9e1a;
}
.unread {
  display: hidden;
}
</style>
